var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTicket20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m7.879 5.05.707.707a.5.5 0 0 0 .765-.637l-.058-.07-.707-.707L12.12.808l1.768 1.767a2.5 2.5 0 0 0 3.536 3.536l1.767 1.768-3.535 3.535-.707-.707a.5.5 0 0 0-.765.638l.058.07.707.706-7.071 7.071-1.768-1.767a2.5 2.5 0 1 0-3.536-3.536L.808 12.121zm4.242 3.536a.5.5 0 0 0-.058.638l.058.069.707.707a.5.5 0 0 0 .765-.638l-.057-.07-.708-.706a.5.5 0 0 0-.707 0M10 6.464a.5.5 0 0 0-.058.638l.058.07.707.707a.5.5 0 0 0 .765-.638l-.058-.07-.707-.707a.5.5 0 0 0-.707 0"
})));
export default SvgIcTicket20X20;